import React from 'react';
import { useSelector } from 'react-redux';

import T from '../i18n/i18n';
import { Loading } from './Loading.styles';

export default () => {
    const loadingSources = useSelector(state => state.loadingState.loadingSources);

    return <Loading className={loadingSources.length > 0 ? 'active' : ''}>
        <T value={"loading"} />
    </Loading>
}
;